export default "__VITE_ASSET__b6073553__"